"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var MyAccountMiniDxp_1 = require("./MyAccountMiniDxp");
var useToken_1 = require("../../../gql/common/hooks/useToken");
var MyAccountEvents_1 = require("../../enum/MyAccountEvents");
var customEvent_1 = require("../../service/customEvent");
var myAccountMiniContainerStyles_1 = require("./myAccountMiniContainerStyles");
var MyAccountMiniContainer = function (_a) {
    var dataTestId = _a.dataTestId, _b = _a.loginInModal, loginInModal = _b === void 0 ? false : _b, dealId = _a.dealId, displayMode = _a.displayMode, introducedEmail = _a.introducedEmail, shouldProceedFlow = _a.shouldProceedFlow;
    var getCurrentToken = useToken_1.default().getCurrentToken;
    var styles = myAccountMiniContainerStyles_1.default();
    var _c = react_1.useState(getCurrentToken()), accessToken = _c[0], setAccessToken = _c[1];
    var updateAccessToken = react_1.useCallback(function () {
        setAccessToken(getCurrentToken());
    }, [accessToken]);
    react_1.useEffect(function () {
        if (!getCurrentToken()) {
            customEvent_1.customEvent.listen(MyAccountEvents_1.MyAccountEvents.ON_STORE_ACCESS_TOKEN, updateAccessToken);
        }
        return function () {
            if (getCurrentToken()) {
                customEvent_1.customEvent.removeListener(MyAccountEvents_1.MyAccountEvents.ON_STORE_ACCESS_TOKEN, updateAccessToken);
            }
        };
    }, [accessToken]);
    return (<core_1.Box className={styles.container}>
      <core_1.Box className={styles.buttonWrapper} data-test={'dxp:mini_my_account:container'}>
        <MyAccountMiniDxp_1.default dealId={dealId} loginInModal={loginInModal} displayMode={displayMode} data-test={dataTestId} introducedEmail={introducedEmail} shouldProceedFlow={shouldProceedFlow}/>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = MyAccountMiniContainer;
